export class HomeSlickComponent {
    protected _currentContext: JQuery = $();

    private classMap = {
        js: {
            slickArrow: ".slick-arrow"
        }
    };

    protected moduleOptions: JQuerySlickOptions = {};

    private _window: JQuery<Window> = $(window);

    public getSlick(): JQuerySlick {
        return this._currentContext.slick("getSlick");
    }

    public destroy(): void {
        this._currentContext.slick("unslick");
    }

    private isInitialized(): boolean {
        return this._currentContext.hasClass("slick-initialized");
    }

    protected bindEvents(): void {
        this._window.on("orientationchange resize", () => {
            if (!this.isInitialized()) {
                this._currentContext.slick(this.moduleOptions);
            } else {
                this._currentContext.slick("resize");
            }
        });

        if (this.moduleOptions.autoplay) {
            $(this.classMap.js.slickArrow, this._currentContext).on({
                mouseenter: () => {
                    this._currentContext.slick("slickPause");
                },
                mouseleave: () => {
                    this._currentContext.slick("slickPlay");
                }
            });
        }
    }

    public init(context: JQuery, options: JQuerySlickOptions): void {
        this._currentContext = context || this._currentContext;
        this.moduleOptions = $.extend({}, options);

        this._currentContext.slick(this.moduleOptions);

        this.bindEvents();
    }

    public static init(context: JQuery, options: JQuerySlickOptions): HomeSlickComponent {
        const slider = new HomeSlickComponent();
        slider.init(context, options);
        return slider;
    }
}
